import React from "react";
import styled from "styled-components";

const Path = styled.path`
  stroke: ${props => props.theme.icon};
`;

const MoonIcon = props => {
  if (window.innerWidth > 1800) {
    return (
      <svg
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        width="15.222"
        height="18.523"
        viewBox="0 0 15.222 18.523"
      >
        <Path
          d="M7.054,1.5a8.222,8.222,0,0,0-3.784.921A8.265,8.265,0,0,1,7.747,9.761,8.265,8.265,0,0,1,3.27,17.1,8.26,8.26,0,1,0,7.054,1.5Z"
          transform="translate(-1.094 -.5)"
          fill="none"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
      </svg>
    );
  } else {
    return (
      <svg
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        width="12.727"
        height="15.1"
        viewBox="0 0 12.727 15.1"
      >
        <Path
          d="M6.27,1.5a6.519,6.519,0,0,0-3,.73,6.546,6.546,0,0,1,0,11.64,6.549,6.549,0,1,0,3-12.37Z"
          transform="translate(-1.093 -.5)"
          fill="none"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
      </svg>
    );
  }
};

export default MoonIcon;
